import React from "react";

import StarIcon from "@mui/icons-material/Star";

import { TooltipIcon } from "./BaseIconTooltip";

export const StarIconTooltip = () => {
  return (
    <TooltipIcon tooltipText="This is your funding account">
      <StarIcon />
    </TooltipIcon>
  );
};
